import React, { CSSProperties, PureComponent } from "react";
import classnames from "classnames";

import * as styles from "./Chip.scss";

export interface IChipProps {
    className?: string;
    style?: CSSProperties;
}

export class Chip extends PureComponent<IChipProps> {
    public render() {
        const { className, ...props } = this.props;
        return (
            <div className={classnames(styles.chip, className)} {...props} />
        );
    }
}
